import React from 'react';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx'

const ExcelExport = ({ data, fileName, title = 'Excel', buttonStyle, variant = 'dark' }) => {
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
    saveAs(blob, `${fileName}.xlsx`);
  };

  const buttonClass = variant === 'light'
    ? 'btn btn-sm btn-rocell-export-light'
    : 'btn btn-sm btn-rocell-export';

  return (
    <button
      className={buttonClass}
      style={buttonStyle}
      onClick={exportToExcel}
    >
      {title}
    </button>
  );
}

export default ExcelExport;